import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <div className="flex items-center gap-2">
            <Link to="/" className="whitespace-nowrap cursor-pointer">
              <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                每日吃瓜<span className="text-primary-500">黑料</span>
              </span>
            </Link>
            <span className="hidden md:inline text-xs text-foreground-500 whitespace-nowrap">每日新料 吃瓜不打烊</span>
          </div>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/" ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="ml-3 px-5 py-2 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              爆料入口
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="flex flex-col px-4 py-4 gap-1 max-w-[1400px] mx-auto">
            <Link to="/" className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 rounded-lg hover:bg-background-100 transition-colors cursor-pointer">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="mt-2 px-4 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-lg text-center hover:bg-primary-600 transition-colors cursor-pointer">爆料入口</Link>
          </div>
        </div>
      )}
    </header>
  );
}